import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils.js';

export type AlertVariant = 'default' | 'info' | 'success' | 'warning' | 'danger';

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
  children: ReactNode;
}

const variantClassName: Record<AlertVariant, string | undefined> = {
  default: undefined,
  info: 'alert--info',
  success: 'alert--success',
  warning: 'alert--warning',
  danger: 'alert--danger',
};

export function Alert({ variant = 'default', className, children, ...props }: AlertProps) {
  return (
    <div className={cn('alert', variantClassName[variant], className)} role="alert" {...props}>
      {children}
    </div>
  );
}

export interface AlertIconProps {
  children: ReactNode;
  className?: string;
}

export function AlertIcon({ children, className }: AlertIconProps) {
  return <span className={cn('alert-icon', className)}>{children}</span>;
}

export interface AlertTitleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function AlertTitle({ className, children, ...props }: AlertTitleProps) {
  return (
    <div className={cn('alert-title', className)} {...props}>
      {children}
    </div>
  );
}

export interface AlertContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function AlertContent({ className, children, ...props }: AlertContentProps) {
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}
